// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"4cd6bbc9","80":"272e104f","2189":"4cd6bbc9","2544":"e6500cdd","8855":"0e312c6c"}[chunkId] + ".chunk.css";
};